export default __webpack_public_path__ + "static/messaging-platform-driveaway-value-2560x400-9b7c73ad82bd4dfbe87f052efcda36da.jpg";